import { ReactNode } from 'react';
import { Stack } from '@mui/material';

import {
	MplStepProgress,
	MplTopSectionHeader,
	StyledDTicketPageLayoutContainer,
	StyledDTicketPageLayoutContent,
	StyledSafeAreaHeader,
} from '@mopla/ui';

export interface IDTicketResumeSubscriptionLayoutProps {
	title: string;
	subtitle: string;
	currentStep: number;
	totalSteps: number;
	onBack: () => void;
	children: ReactNode;
	dataTestId?: string;
}

export const DTicketResumeSubscriptionLayout = ({
	title,
	subtitle,
	currentStep,
	totalSteps,
	onBack,
	children,
	dataTestId,
}: IDTicketResumeSubscriptionLayoutProps) => {
	return (
		<StyledDTicketPageLayoutContainer data-testid={dataTestId}>
			<StyledSafeAreaHeader>
				<MplTopSectionHeader
					title={title}
					subtitle={subtitle}
					onBack={onBack}
					dataTestId={dataTestId}
				/>
			</StyledSafeAreaHeader>
			<Stack
				sx={{
					mx: -2,
					mb: 1,
					'& .MuiLinearProgress-root': { height: 3 },
				}}
			>
				<MplStepProgress value={currentStep} maxSteps={totalSteps} />
			</Stack>

			<StyledDTicketPageLayoutContent scrollable sx={{ pb: '140px', mb: 4 }}>
				{children}
			</StyledDTicketPageLayoutContent>
		</StyledDTicketPageLayoutContainer>
	);
};
